import { linearGradient } from '../../../../internal/styles/linearGradient';
import { type BannerBoxTokens } from '../types';

export const bannerBox: BannerBoxTokens = {
  colors: {
    borderTop: 'secondary.50',
    background: '#f9f9f7',
    background2: '#198cfb',
    background5: '#0A8EFF',
  },
  backgroundImage: {
    base: null,
    gradient: linearGradient('90deg', ['#002C52', '#000D29']),
  },
};
